import React, { useState, useMemo } from 'react';
import { usePopper } from 'react-popper';
import { ListMenu } from '../../ListMenu';
import {
  INVOICE_ACTIONS,
  CANCELED_INVOICE_MENU_ACTIONS,
  DEFAULT_INVOICE_MENU_ACTIONS,
} from '../../../consts/consts';
import { useStore } from '../../../../../../store';
import { HUB_MODALS } from '../../InvoiceHubModals';
import { isInvoiceStatusCancelled } from '../../../utils';

export const InvoiceActionsMenu = ({ referenceElement, onClose } : { referenceElement: any, onClose: () => void }) => {
  const setActiveModal = useStore(state => state.setActiveModal);
  const selectedInvoice = useStore(state => state.selectedInvoice);
  const [popperElement, setPopperElement] = useState<any>();
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'left-start',
    modifiers: [{ name: 'offset', options: { offset: [0, 4] } }],
  });
  const handleActionOnClick = (name: string) => {
    if (name === INVOICE_ACTIONS.SHARE_LINK) setActiveModal(HUB_MODALS.SHARE_LINK);
    if (name === INVOICE_ACTIONS.DOWNLOAD_PRINT_PDF) {
      onClose();
      window.open(selectedInvoice?.paymentUrl, '_blank');
    }
    if (name === INVOICE_ACTIONS.PREVIEW) setActiveModal(HUB_MODALS.INVOICE_PAGE);
    if (name === INVOICE_ACTIONS.CANCEL) setActiveModal(HUB_MODALS.CANCEL_INVOICE);
  };

  const menuItems = useMemo(() => {
    if (isInvoiceStatusCancelled(selectedInvoice.status)) return CANCELED_INVOICE_MENU_ACTIONS;
    return DEFAULT_INVOICE_MENU_ACTIONS;
  }, [selectedInvoice.status]);

  return (
    <div
      className='absolute z-20'
      ref={setPopperElement}
      style={styles.popper}
      {...attributes.popper}
    >
      <ListMenu testId='invoice-hub__actions-sub-menu' menuItems={menuItems} onMenuItemClick={handleActionOnClick} className='shadow-popOver w-[238px]' />
    </div>
  );
};
